import { Connection } from '@wix/cms-viewer-core'

export const convertOldConnectionToNew = (connection) => {
  const { compId, role, config: { properties = {}, totalCount } } = connection
  const newConnectionDescriptor = Connection.makeDescriptor()

  for (const [path, propertyConnectionDescriptor] of Object.entries(properties)) {
    const pathParts = path.split('.')
    if (pathParts.length > 1) {
      newConnectionDescriptor.properties[pathParts.at(0)] = convertOldConnectionToNew({
        role,
        config: { properties: { [pathParts.at(1)]: propertyConnectionDescriptor } },
      })
    } else if (path === '$text') {
      newConnectionDescriptor.dynamicProperties.text = convertToTextDynamicProperty(propertyConnectionDescriptor)
    } else {
      newConnectionDescriptor.extraData = convertToExtraData(propertyConnectionDescriptor)
      newConnectionDescriptor.properties[path] = convertToNewProperty(role, propertyConnectionDescriptor)
    }
  }

  if (totalCount) {
    newConnectionDescriptor.dynamicProperties.totalCount = convertToTotalCountDynamicProperty(totalCount)
  }

  return compId ? Connection.make({ compId, ...newConnectionDescriptor }) : newConnectionDescriptor
}

const convertToNewProperty = (role, { fieldName, format }) => ({
  fieldName,
  format,
  ...(convertRoleToDataType[role]?.() ?? convertRoleToDataType.default()),
})

const convertRoleToDataType = {
  textRole: () => ({ dataType: 'text' }),
  checkboxRole: () => ({ dataType: 'boolean' }),
  addressInputRole: () => ({dataType: 'schema', schema: {}}),
  default: () => ({ dataType: 'unknown' }),
}

const convertToTextDynamicProperty = ({ fieldName, format, ...rest }) => ({
  fieldName,
  format,
  propName: 'text',
  typeMapping: {
    richtext: 'html',
    url: '_hack_link', // special prop for component adapter being able to do hack
  },
  extraData: convertToExtraData(rest),
})

const convertToTotalCountDynamicProperty = ({ prop }) => ({ propName: prop === '$text' ? 'text' : prop })

const convertToExtraData = ({ linkRel, linkTarget }) => {
  const extraDataEntries = []
  if (linkRel !== undefined) {
    extraDataEntries.push(['rel', linkRel])
  }
  if (linkTarget !== undefined) {
    extraDataEntries.push(['target', linkTarget])
  }
  return extraDataEntries.length > 0 ? Object.fromEntries(extraDataEntries) : {}
}